// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"21f605cb","284":"ab26f1d8","377":"f473d08f","453":"cf9b2cd8","659":"9ecdb9d2","671":"8673601d","874":"0c54b715","975":"0735f9cd"}[chunkId] + ".chunk.js";
};